import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { CONTACT } from "@/lib/content";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Process", href: "#process" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/85 border-b border-[#E2E8F0] shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3" onClick={(e)=>{e.preventDefault();go('#top');}}>
          <img src={LOGO_URL} alt="Kelowna Carpet Cleaning" className="h-14 w-14 object-contain" />
          <span className="hidden sm:block font-display font-extrabold leading-none text-[#1A2A5E] text-lg tracking-tight">
            KELOWNA<br /><span className="text-[#2B4BB8] text-sm tracking-[0.15em] font-semibold">CARPET CLEANING</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(n.href)}
              className="text-sm font-semibold text-[#0F172A] hover:text-[#2B4BB8] transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="header-call-btn"
            className="hidden md:flex items-center gap-2 text-sm font-bold text-[#1A2A5E] hover:text-[#2B4BB8]"
          >
            <Phone className="w-4 h-4" /> {CONTACT.phone}
          </a>
          <button
            data-testid="header-book-btn"
            onClick={() => go("#book")}
            className="hidden sm:inline-flex bg-[#1A2A5E] text-white text-sm font-bold px-5 py-3 rounded-sm hover:bg-[#2B4BB8] transition-colors"
          >
            Get a Free Quote
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#1A2A5E]"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-[#E2E8F0] px-5 py-4 space-y-1">
          {NAV.map((n) => (
            <button
              key={n.href}
              onClick={() => go(n.href)}
              className="block w-full text-left py-3 font-semibold text-[#0F172A] border-b border-[#F1F5F9]"
            >
              {n.label}
            </button>
          ))}
          <button
            onClick={() => go("#book")}
            className="mt-3 w-full bg-[#1A2A5E] text-white font-bold py-3 rounded-sm"
          >
            Get a Free Quote
          </button>
        </div>
      )}
    </header>
  );
}
